import { Injectable, signal } from '@angular/core';

/**
 * Holds the current page title (already translated, "| ATC" suffix stripped) so
 * the topbar can render it. Fed by TranslocoTitleStrategy on every navigation.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleService {
    readonly title = signal('');
}
